import { render, staticRenderFns } from "./TaskDetailsPage.vue?vue&type=template&id=c257cdd0&scoped=true&"
import script from "./TaskDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./TaskDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c257cdd0",
  null
  
)

export default component.exports